<template>
  <el-dialog
    :visible.sync="show"
    :title="`款号：${goods_kh}`"
    :close-on-click-modal="false"
  >
    <el-table :data="list" border size="small">
      <el-table-column
        prop="plan_price"
        label="代采单价"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="co_val"
        label="颜色"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="si_val"
        label="尺码"
        align="center"
      ></el-table-column>
      <el-table-column label="选择开单" align="center" width="160px">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.cg_num"
            size="small"
            :min="0"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="剩余" align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              class="curosr full"
              type="text"
              @click="tapLeftNum(scope.row)"
            >
              {{ calcLeftNum(scope.row) }}
            </el-button>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="前置数量" align="center">
        <template slot-scope="scope">
          <div>
            {{ calcDkNum(scope.row) }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-table :data="counting_dialog.info.goods" border size="small">
        <el-table-column prop="price" label="代采单价" align="center">
            <template slot-scope="scope">
            <div>
                {{scope.row.new_price || scope.row.price}}
            </div>
            </template>
        </el-table-column>
        <el-table-column prop="co_val" label="颜色" align="center"></el-table-column>
        <el-table-column prop="si_val" label="尺码" align="center"></el-table-column>
        <el-table-column label="选择开单" align="center" width="160px">
            <template slot-scope="scope">
            <el-input-number
                @change="orderNumChange($event, scope.$index)"
                :value="scope.row.orderNum"
                size="small"
                :min="0"
            ></el-input-number>
            </template>
        </el-table-column>
        <el-table-column label="剩余" align="center">
            <template slot-scope="scope" >
            <div @click="orderNumChange(scope.row.num - scope.row.stockoutNum - scope.row.orderNum, scope.$index)" style="cursor:pointer">
                {{scope.row.num - scope.row.orderNum - scope.row.stockoutNum > 0 ? scope.row.num - scope.row.orderNum - scope.row.stockoutNum : 0}}
            </div>
            </template>
        </el-table-column>
        <el-table-column label="前置数量" prop="addedNum" align="center"></el-table-column>
    </el-table> -->

    <div slot="footer" style="display: flex; justify-content: space-between">
      <el-button
        type="infor"
        style="width: 20%; margin: 0"
        @click="orderNumReset"
        >重置</el-button
      >
      <el-button
        type="danger"
        style="width: 20%; margin: 0"
        @click="orderNumAll"
        >全选</el-button
      >
      <el-button
        type="primary"
        style="width: 55%; margin: 0"
        @click="orderNumConfirm"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      goods_no: "",
      goods_kh: "",
      show: false,
    };
  },

  methods: {
    calling(goods_no) {
      this.goods_no = goods_no;
      this.list = [];
      this.$parent._loopSku(goods_no, (row) => {
        this.goods_kh = row.goods_kh;
        this.list.push({
          plan_price: row.plan_price,
          co_val: row.co_val,
          si_val: row.si_val,
          cg_num: row.cg_num,
          plan_num: row.plan_num,
          stop_num: row.stop_num,
          sku: row.sku,
        });
      });
      this.show = true;
    },

    // 重置开单数量
    orderNumReset() {
      this.list.forEach((row) => {
        this.orderNumChange(row, 0);
      });
    },

    // 全选开单数量
    orderNumAll() {
      this.list.forEach((row) => {
        this.orderNumChange(row, this.calcLeftNum(row));
      });
    },

    // 确定
    orderNumConfirm() {
      this.$emit(
        "confirm",
        JSON.parse(JSON.stringify(this.list)),
        this.goods_no
      );
      this.show = false;
    },

    // 点一下剩余数量 就把剩余的全给开单数量
    tapLeftNum(row) {
      let left_num = this.calcLeftNum(row);
      if (left_num == 0) {
        this.orderNumChange(row, 0);
        return;
      }
      this.orderNumChange(row, left_num);
    },

    // 变化数量
    orderNumChange(row, num) {
      if (num > 0) {
        num += row.cg_num;
      }
      row.cg_num = num;
    },

    //
    calcLeftNum(row) {
      return this.$parent.calcLeftNum(row);
    },
    calcDkNum(row) {
      return this.$parent.calcDkNum(row);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/purchaseverify/components/KdDialog.vue